import axios from 'axios';

const instance = axios.create({
    // baseURL: 'https://api.bilbolag1.se/api/cars'
    baseURL: 'https://api.bilbolaget.nu/api/cars'
});


export default instance;